import { render, staticRenderFns } from "./MasksIcon.vue?vue&type=template&id=e145d12e&"
import script from "./MasksIcon.vue?vue&type=script&lang=ts&"
export * from "./MasksIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports